/*============================================================================
  Gestione drodown selezione varianti schda prodotto
==============================================================================*/
(function () {
	
	/**
	 * Oggetto gestione note nella pagina carrello
	 * @private
	 */
	function _cosCartNote() {
		let $self = this;
		
		let $noteReal = null;
		let $noteDesktop = null;
		let $noteMobile = null;
		
		//True se è stata inizializzata la procedura la prima volta
		let $noteInitialized = false;
		let $ismobile = false; //Identifica se l'ultima volta che gesitio le note ero in mobile
		
		
		
		this.settings = {
			selector: {
				noteReal: "#cart_note_to_send",
				noteDesktop: "#cartNoteDesktop",
				noteMobile: "#cartNoteMobile"
			}
		};
		
		
		
		/**
		 * Gestione del campo note nel form della pagina Carrello
		 *
		 * Tutto funziona solo se esistino almeno le note reali $noteReal in base ai settings del tema
		 */
		this.init = function () {
			$noteReal = $(this.settings.selector.noteReal);
			$noteDesktop = $(this.settings.selector.noteDesktop);
			$noteMobile = $(this.settings.selector.noteMobile);
			$ismobile = resolution_IsMobile();
			$noteInitialized = false;
			if (this.itemExists($noteReal)) {
				$self.addNote();
				$(window).on('resize', function () {
					$self.addNote();
				});
			}
			
			
		};
		
		/**
		 * Estraggo le note
		 *
		 * 1) Se è la prima volta che eseugo la procedura (INITIALIZE oggetto) prendo quelle dell'oogetto reale cart.json
		 * 2) Se L'oggetto Mobile / Desktop esiste prelevo le note richieste oppure ritorno sempre l'ooteggo reale di cart.json inizializzato al punto 1
		 * @param $item
		 * @returns {this | string | jQuery | *}
		 */
		this.getNote = function ($item) {
			if ($noteInitialized) {
				if (this.itemExists($item) && $item.html() !== "") {
					return $item.html();
				}
				
			}
			return $noteReal.html();
		};
		
		this.itemExists = function ($item) {
			return ($item.length === 1);
		};
		
		/**
		 * Elimino il contenuto dell'oggetto $item
		 * @param $item
		 */
		this.itemClear = function ($item) {
			if (this.itemExists($item)) {
				$item.html("");
				$item.addClass('hidden');
			}
		};
		
		this.addSetNoteIntoContainer = function ($noteOrigin, $noteDestination) {
			if (this.itemExists($noteDestination)) {
				$noteDestination.append($noteReal);
				$noteDestination.removeClass('hidden');
				$noteReal.removeClass('hidden');
				$noteOrigin.addClass('hidden');
			}
		};
		
		this.addNote = function () {
			/**
			 * Devo attivare il cambio note solo se la risolzuione è diversa dall'ultima volta che l'ho eseguita
			 */
			if (resolution_IsMobile() != $ismobile || !$noteInitialized) {
				if (resolution_IsMobile()) {
					/**
					 * Se ruotando il dispositivo o facendo un resize del browser passo dalla risoluzione Desktop a quella Mobile, devo salvare le note e spostare il contenuto
					 * @type {_cosCart|string|jQuery|*}
					 */
					$self.addSetNoteIntoContainer($noteDesktop, $noteMobile);
				} else {
					/**
					 * Se ruotando il dispositivo o facendo un resize del browser passo dalla risoluzione Mobile alle altre, devo salvare le note e spostare il contenuto
					 * @type {_cosCart|string|jQuery|*}
					 */
					$self.addSetNoteIntoContainer($noteMobile, $noteDesktop);
				}
				$noteInitialized = true;
				$ismobile = resolution_IsMobile();
			}
		};
	}
	
	function _setSummaryColFixed () {
		
		let $self = this;
		
		let $summaryFixed = true;
		let footerPositionTop = $('#shopify-section-footer').offset().top;
		this.init = function() {
			$(window).on('resize', theme.debounce($self.checkFixed, 150).bind(this))
				.on('scroll', $self.checkFixed);
		
		};
		
		this.checkFixed = function () {
			let block_dx = $('.block-dx', '#cosCart');
			let blockDxHeight = block_dx.height();
			let headerWrapperHeight = $('.header-wrapper').height();
			if (resolution_IsMobile() || block_dx.height()> $(window).height()) {
				block_dx.removeClass('fixed');
				return true;
			}
			
			let top_of_screen = $(window).scrollTop();
			let padding_top = parseInt($('.main-content').css('paddingTop')) | 0;
			

			
			
			let footerHeight = $('#shopify-section-footer').height();
			
			//console.log('headerWrapperHeight',headerWrapperHeight);
			let startToScroll = blockDxHeight - padding_top - headerWrapperHeight;
			let marginTop=footerPositionTop-blockDxHeight-padding_top;
			
			
			
			if (top_of_screen >= startToScroll) {
				block_dx.removeClass('fixed');
				block_dx.css('margin-top', marginTop);
				$summaryFixed = false;
				
			} else {
				block_dx.addClass('fixed');
				block_dx.css('margin-top', '');
				$summaryFixed = true;
			}
		}
	}
	
	/**
	 * Oggetto generale per gestione carrello
	 * @private
	 */
	function _cosCart() {
		let $body = $("body");
		let $self = this;
		let $noteController = null;
		this.settings = {};
		
		let scroltof = null;
		this.handleEvent = function () {
			$('form', '#cosCart').validate({
				rules: {
					"attributes[acceptrivacy]": {
						required: true
					}
				},
				errorPlacement: function (error, element) {
					if (element.attr('type') == 'checkbox') {
						error.insertAfter(element.parent());
					} else {
						error.insertAfter(element);
					}
					// console.log('errorPlacement');
					
				},
				submitHandler: function (form) {
					/**
					 * @todo Verificare il funzionamento dopo l'attivazione del pickup in store
					 */
					form.submit();
				}
			});
			
			
		};
		
		
		
		this.setBlockDxFixed = function () {
			let calcLimit = $('#shopify-section-footer').position().top - $('.block-dx', '#cosCart').outerHeight()-10;
			let marginTopScrollToFixed=$('#cosCart').position().top;
			let wrapperHeight=$('.block-dx', '#cosCart').outerHeight() + $('.header-container').offset().top+ $('.header-container').outerHeight();
			
			console.log('setBlockDxFixed',$(window).height(),wrapperHeight)
			if ($(window).height()>wrapperHeight) {
				/*$self.scroltof=$('.block-dx', '#cosCart').scrollToFixed({
					marginTop: marginTopScrollToFixed,
					limit: calcLimit
				});*/
				$('.block-dx', '#cosCart').css('position','sticky');
				$('.block-dx', '#cosCart').css('top',marginTopScrollToFixed);
			} else {
				$('.block-dx', '#cosCart').css('position','relative');
				$('.block-dx', '#cosCart').css('top','');
			}
		};
		
		this.init = function (dom) {
			$noteController = new _cosCartNote();
			$noteController.init();
			
			let resizeObserver = new ResizeObserver(() => {
				$self.setBlockDxFixed();
			});
			//resizeObserver.observe($('#pickup-container')[0]);
			
			$self.setBlockDxFixed();
			
			$self.handleEvent();
			
			
		};
	}
	
	// Export variable
	let cc = new _cosCart();
	window.cosCart = {
		init: cc.init.bind(_cosCart),
	};
})();
/* Updated on: 12th Aug, 4:32:11 PM */